/**
 * Coups de pouce — Attendu 679 « Probabilité entre 0 et 1 ».
 *
 * Particularité : gen_679 persiste des generator_key au niveau EXERCICE
 * (echelle_qualitative, droite_graduee_probabilite, …) — une entrée sert donc
 * tous les formats d'un même exercice.
 *
 * Règle absolue : l'aide porte sur d'AUTRES événements que ceux des pools du
 * générateur. Emphase : **texte** (pas de HTML brut). Pas de tiret cadratin.
 */

// ── Échelle qualitative : quatre événements tombent sur la droite 0-1 ──
// Animation SMIL au clic (id cp679play1), une lecture puis gel : chaque
// événement apparaît puis son point tombe à sa place sur la droite.
// Aucun de ces événements ne figure dans les pools de gen_679.
const SVG_ECHELLE_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 264" role="img"
     aria-label="Une droite graduée de 0 à 1 avec les cinq zones : impossible, peu probable, probable, très probable, certain. Quatre événements tombent sur la droite : un chat qui parle sur 0, obtenir deux 6 avec deux dés vers 0,05, le prochain bébé est une fille sur 0,5, la semaine a 7 jours sur 1">
  <g id="cp679play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- droite 0-1 -->
  <line x1="30" y1="150" x2="330" y2="150" stroke="#0f172a" stroke-width="2"/>
  <line x1="30" y1="144" x2="30" y2="156" stroke="#0f172a" stroke-width="2"/>
  <line x1="180" y1="144" x2="180" y2="156" stroke="#0f172a" stroke-width="2"/>
  <line x1="330" y1="144" x2="330" y2="156" stroke="#0f172a" stroke-width="2"/>
  <text x="30" y="172" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">0</text>
  <text x="180" y="172" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">0,5</text>
  <text x="330" y="172" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">1</text>
  <!-- zones -->
  <text x="30" y="190" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">impossible</text>
  <text x="90" y="202" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">peu probable</text>
  <text x="180" y="190" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">probable</text>
  <text x="270" y="202" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">très probable</text>
  <text x="330" y="190" font-size="11" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">certain</text>
  <!-- ① Un chat qui parle → 0 (rangée 1) -->
  <g opacity="0">
    <text x="8" y="46" font-size="12" font-weight="700" fill="#dc2626" font-family="system-ui,sans-serif">Un chat qui parle</text>
    <circle cx="30" cy="150" r="6" fill="#dc2626">
      <animate attributeName="cy" values="56;150" keyTimes="0;1" dur="0.5s" begin="cp679play1.click+0.3s" fill="freeze"/>
    </circle>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play1.click+0.2s" fill="freeze"/>
  </g>
  <!-- ② Deux 6 avec deux dés → ~0,05 (rangée 2) -->
  <g opacity="0">
    <text x="44" y="70" font-size="12" font-weight="700" fill="#EF9F27" font-family="system-ui,sans-serif">Deux 6 avec deux dés</text>
    <circle cx="50" cy="150" r="6" fill="#EF9F27">
      <animate attributeName="cy" values="80;150" keyTimes="0;1" dur="0.5s" begin="cp679play1.click+1.3s" fill="freeze"/>
    </circle>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play1.click+1.2s" fill="freeze"/>
  </g>
  <!-- ③ Le prochain bébé est une fille → 0,5 (rangée 3) -->
  <g opacity="0">
    <text x="180" y="94" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">Le prochain bébé est une fille</text>
    <circle cx="180" cy="150" r="6" fill="#1D9E75">
      <animate attributeName="cy" values="104;150" keyTimes="0;1" dur="0.5s" begin="cp679play1.click+2.3s" fill="freeze"/>
    </circle>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play1.click+2.2s" fill="freeze"/>
  </g>
  <!-- ④ La semaine a 7 jours → 1 (rangée 4) -->
  <g opacity="0">
    <text x="352" y="118" font-size="12" font-weight="700" fill="#378ADD" text-anchor="end" font-family="system-ui,sans-serif">La semaine a 7 jours</text>
    <circle cx="330" cy="150" r="6" fill="#378ADD">
      <animate attributeName="cy" values="126;150" keyTimes="0;1" dur="0.5s" begin="cp679play1.click+3.3s" fill="freeze"/>
    </circle>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play1.click+3.2s" fill="freeze"/>
  </g>
  <!-- conclusions (décalées sous le vocabulaire des zones) -->
  <g opacity="0">
    <rect x="30" y="230" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="238" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Impossible vaut 0, certain vaut 1.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play1.click+4.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="30" y="248" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="256" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Une chance sur deux vaut 0,5.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play1.click+4.8s" fill="freeze"/>
  </g>
</svg>`.trim();

// Entrée par défaut des formats classer / tableau_vf / ordonner.
const CP_ECHELLE = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Pour classer un événement, demande-toi où il tombe sur cette droite : **sûr que non** (0), **sûr que oui** (1), ou **entre les deux**.',
            ],
            svg: SVG_ECHELLE_ANIM,
        },
    ],
};

// ── Variante RELIER : compter les cas (id cp679play2) ──
// Le relier apparie des étiquettes « une chance sur N » : le geste utile est
// de compter les résultats possibles puis les gagnants. Exemples hors pool :
// obtenir un 6 (le pool relier dit « un 6 avec un dé équilibré » — ici on
// VISUALISE les 6 faces, on ne pose pas la question), roue à 4 secteurs.
const SVG_COMPTER_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 258" role="img"
     aria-label="Un dé : six faces possibles, une seule donne le 6, donc une chance sur six. Une roue à quatre secteurs dont un colorié : une chance sur quatre. Aucun gagnant : impossible, zéro. Tous gagnants : certain, un">
  <g id="cp679play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- ── le dé : 6 faces, 1 gagnante ── -->
  <text x="8" y="46" font-size="12" fill="#64748b" font-family="system-ui,sans-serif">Obtenir un 6 avec un dé :</text>
  <rect x="8" y="56" width="30" height="30" rx="5" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <rect x="44" y="56" width="30" height="30" rx="5" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <rect x="80" y="56" width="30" height="30" rx="5" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <rect x="116" y="56" width="30" height="30" rx="5" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <rect x="152" y="56" width="30" height="30" rx="5" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <rect x="188" y="56" width="30" height="30" rx="5" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <text x="23" y="77" font-size="14" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">1</text>
  <text x="59" y="77" font-size="14" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2</text>
  <text x="95" y="77" font-size="14" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">3</text>
  <text x="131" y="77" font-size="14" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">4</text>
  <text x="167" y="77" font-size="14" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">5</text>
  <g opacity="0">
    <rect x="188" y="56" width="30" height="30" rx="5" fill="#F97316"/>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play2.click+0.5s" fill="freeze"/>
  </g>
  <text x="203" y="77" font-size="14" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">6</text>
  <g opacity="0">
    <text x="352" y="70" font-size="12" font-weight="700" fill="#F97316" text-anchor="end" font-family="system-ui,sans-serif">1 gagnante sur 6</text>
    <text x="352" y="86" font-size="12" font-weight="700" fill="#F97316" text-anchor="end" font-family="system-ui,sans-serif">une chance sur six</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play2.click+1.2s" fill="freeze"/>
  </g>
  <!-- ── la roue : 4 secteurs, 1 gagnant ── -->
  <text x="8" y="126" font-size="12" fill="#64748b" font-family="system-ui,sans-serif">Tomber sur le secteur colorié de la roue :</text>
  <path d="M62 172 L62 138 A34 34 0 0 1 96 172 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <path d="M62 172 L96 172 A34 34 0 0 1 62 206 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <path d="M62 172 L62 206 A34 34 0 0 1 28 172 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <path d="M62 172 L28 172 A34 34 0 0 1 62 138 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <g opacity="0">
    <path d="M62 172 L62 138 A34 34 0 0 1 96 172 Z" fill="#F97316"/>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play2.click+2.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="352" y="168" font-size="12" font-weight="700" fill="#F97316" text-anchor="end" font-family="system-ui,sans-serif">1 secteur sur 4</text>
    <text x="352" y="184" font-size="12" font-weight="700" fill="#F97316" text-anchor="end" font-family="system-ui,sans-serif">une chance sur quatre</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play2.click+2.9s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="8" y="224" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="24" y="232" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Aucune façon de gagner, c'est impossible (0).</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play2.click+3.9s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="8" y="242" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="24" y="250" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Toutes les façons gagnent, c'est certain (1).</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play2.click+4.5s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_RELIER_PAGES = [
    {
        titre: 'La méthode',
        lignes: [
            'Compte **tous les résultats possibles**, puis ceux qui **font gagner**.',
            'S\'il y a **6 résultats** et **1 seul gagnant**, c\'est **une chance sur six**.',
        ],
        svg: SVG_COMPTER_ANIM,
    },
];

// ── Droite graduée : compter les traits (id cp679play3) ──
// Sert la saisie ET le QCM (clé exercice). Les valeurs d'exemple (0,7 et
// 0,25) appartiennent forcément au pool (il couvre tous les dixièmes), mais
// chaque tirage a SON point à SA position : l'aide enseigne le comptage.
const SVG_LIRE_DROITE_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 230" role="img"
     aria-label="Une droite graduée de 0 à 1 avec un petit trait tous les dixièmes. On compte les traits jusqu'au point orange : sept traits, donc 0,7. Un second point vert est à mi-chemin entre 0,2 et 0,3 : c'est 0,25">
  <g id="cp679play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- droite et graduations -->
  <line x1="30" y1="100" x2="330" y2="100" stroke="#0f172a" stroke-width="2"/>
  <line x1="30" y1="92" x2="30" y2="108" stroke="#0f172a" stroke-width="2"/>
  <line x1="180" y1="92" x2="180" y2="108" stroke="#0f172a" stroke-width="2"/>
  <line x1="330" y1="92" x2="330" y2="108" stroke="#0f172a" stroke-width="2"/>
  <line x1="60" y1="95" x2="60" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="90" y1="95" x2="90" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="120" y1="95" x2="120" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="150" y1="95" x2="150" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="210" y1="95" x2="210" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="240" y1="95" x2="240" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="270" y1="95" x2="270" y2="105" stroke="#64748b" stroke-width="1"/>
  <line x1="300" y1="95" x2="300" y2="105" stroke="#64748b" stroke-width="1"/>
  <text x="30" y="126" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">0</text>
  <text x="180" y="126" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">0,5</text>
  <text x="330" y="126" font-size="13" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">1</text>
  <!-- point orange sur le 7e trait (visible avant le clic) -->
  <circle cx="240" cy="100" r="6" fill="#F97316"/>
  <!-- comptage des traits 1 à 7 -->
  <text x="60" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">1<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+0.3s" fill="freeze"/></text>
  <text x="90" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">2<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+0.65s" fill="freeze"/></text>
  <text x="120" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">3<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+1s" fill="freeze"/></text>
  <text x="150" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">4<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+1.35s" fill="freeze"/></text>
  <text x="180" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">5<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+1.7s" fill="freeze"/></text>
  <text x="210" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">6<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+2.05s" fill="freeze"/></text>
  <text x="240" y="144" font-size="11" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">7<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.2s" begin="cp679play3.click+2.4s" fill="freeze"/></text>
  <g opacity="0">
    <text x="240" y="52" font-size="13" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">7 traits, c'est 0,7</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play3.click+3s" fill="freeze"/>
  </g>
  <!-- point vert entre 0,2 et 0,3 -->
  <g opacity="0">
    <circle cx="105" cy="100" r="6" fill="#1D9E75"/>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play3.click+4.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="105" y="76" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">entre 0,2 et 0,3, c'est 0,25</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play3.click+4.9s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="30" y="188" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="196" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Chaque petit trait vaut 0,1.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play3.click+5.9s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="30" y="206" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="46" y="214" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Un point entre deux traits se lit à 0,05 près.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play3.click+6.5s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_DROITE = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Chaque petit trait vaut **0,1**. **Compte les traits** depuis 0 jusqu\'au point.',
            ],
            svg: SVG_LIRE_DROITE_ANIM,
        },
    ],
};

// ── Hasard (QCM) : peut-on prévoir le résultat ? (id cp679play4) ──
// Dé à 8 faces et côtés d'un carré : hors des pools du générateur.
const SVG_HASARD_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 230" role="img"
     aria-label="Deux situations : lancer un dé à 8 faces, le résultat est imprévisible, c'est aléatoire. Compter les côtés d'un carré, le résultat est toujours 4, ce n'est pas aléatoire">
  <g id="cp679play4" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- carte 1 : dé à 8 faces -->
  <rect x="20" y="40" width="150" height="120" rx="10" fill="none" stroke="#94a3b8" stroke-width="1.5"/>
  <text x="95" y="62" font-size="12" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">Lancer un dé</text>
  <text x="95" y="78" font-size="12" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">à 8 faces</text>
  <rect x="80" y="88" width="30" height="30" rx="6" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <text x="95" y="110" font-size="16" font-weight="700" fill="#F97316" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">?<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play4.click+0.5s" fill="freeze"/></text>
  <text x="95" y="148" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">aléatoire<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play4.click+1.2s" fill="freeze"/></text>
  <!-- carte 2 : côtés d'un carré -->
  <rect x="190" y="40" width="150" height="120" rx="10" fill="none" stroke="#94a3b8" stroke-width="1.5"/>
  <text x="265" y="62" font-size="12" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">Compter les côtés</text>
  <text x="265" y="78" font-size="12" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">d'un carré</text>
  <rect x="251" y="88" width="28" height="28" fill="none" stroke="#1E3A8A" stroke-width="2"/>
  <text x="265" y="109" font-size="16" font-weight="700" fill="#64748b" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">4<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play4.click+2s" fill="freeze"/></text>
  <text x="265" y="148" font-size="13" font-weight="700" fill="#dc2626" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">pas aléatoire<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play4.click+2.8s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="184" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="192" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Impossible de prévoir, c'est aléatoire.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play4.click+4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="202" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="210" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Résultat toujours pareil, ce n'est pas aléatoire.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play4.click+4.6s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_HASARD_PAGES = [
    {
        titre: 'La méthode',
        lignes: [
            'Une expérience est **aléatoire** quand on **ne peut pas prévoir** son résultat à l\'avance.',
        ],
        svg: SVG_HASARD_ANIM,
    },
];

// ── Issues (saisie) : compter les résultats possibles (id cp679play5) ──
// Roue à 3 secteurs et sac 3 noires + 1 blanche : hors des pools.
const SVG_ISSUES_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 250" role="img"
     aria-label="Une roue à trois secteurs : on compte un, deux, trois, donc 3 issues. Un sac de quatre boules, trois noires et une blanche : quatre boules mais deux couleurs seulement, donc 2 issues">
  <g id="cp679play5" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- roue à 3 secteurs -->
  <text x="70" y="46" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">Tourner la roue</text>
  <path d="M70 90 L70 56 A34 34 0 0 1 99.4 107 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <path d="M70 90 L99.4 107 A34 34 0 0 1 40.6 107 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <path d="M70 90 L40.6 107 A34 34 0 0 1 70 56 Z" fill="none" stroke="#1E3A8A" stroke-width="1.5"/>
  <g opacity="0">
    <path d="M70 90 L70 56 A34 34 0 0 1 99.4 107 Z" fill="#F9731633" stroke="#F97316" stroke-width="1.5"/>
    <text x="84" y="86" font-size="12" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">1</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play5.click+0.5s" fill="freeze"/>
  </g>
  <g opacity="0">
    <path d="M70 90 L99.4 107 A34 34 0 0 1 40.6 107 Z" fill="#F9731633" stroke="#F97316" stroke-width="1.5"/>
    <text x="70" y="112" font-size="12" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">2</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play5.click+1.1s" fill="freeze"/>
  </g>
  <g opacity="0">
    <path d="M70 90 L40.6 107 A34 34 0 0 1 70 56 Z" fill="#F9731633" stroke="#F97316" stroke-width="1.5"/>
    <text x="56" y="86" font-size="12" font-weight="700" fill="#F97316" text-anchor="middle" font-family="system-ui,sans-serif">3</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play5.click+1.7s" fill="freeze"/>
  </g>
  <text x="70" y="140" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">3 issues<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play5.click+2.4s" fill="freeze"/></text>
  <!-- sac : 3 noires + 1 blanche -->
  <text x="262" y="46" font-size="12" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">Tirer une boule (couleur)</text>
  <circle cx="232" cy="72" r="10" fill="#0f172a"/>
  <circle cx="262" cy="72" r="10" fill="#0f172a"/>
  <circle cx="292" cy="72" r="10" fill="#0f172a"/>
  <circle cx="247" cy="98" r="10" fill="#ffffff" stroke="#0f172a" stroke-width="1.5"/>
  <g opacity="0">
    <text x="262" y="140" font-size="13" fill="#64748b" text-anchor="middle" font-family="system-ui,sans-serif">4 boules</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play5.click+3.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <line x1="234" y1="136" x2="290" y2="136" stroke="#dc2626" stroke-width="2"/>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.3s" begin="cp679play5.click+4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="262" y="158" font-size="12" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2 couleurs (noir, blanc)</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play5.click+4.6s" fill="freeze"/>
  </g>
  <text x="262" y="178" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" opacity="0" font-family="system-ui,sans-serif">2 issues<animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play5.click+5.2s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="204" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="212" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">Compte les résultats différents, pas les objets.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play5.click+6.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="222" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="230" font-size="13" fill="#0f172a" font-family="system-ui,sans-serif">4 boules mais 2 couleurs, cela fait 2 issues.</text>
    <animate attributeName="opacity" values="0;1" keyTimes="0;1" dur="0.4s" begin="cp679play5.click+6.8s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_ISSUES = {
    pages: [
        {
            titre: 'La méthode',
            lignes: [
                'Les **issues**, ce sont tous les **résultats possibles**. Compte les résultats **différents**, pas les objets.',
            ],
            svg: SVG_ISSUES_ANIM,
        },
    ],
};

const CP_679 = {
    // Variante par motif : le texte du relier commence par « Relie chaque
    // événement » (exclusif à ce format). Les autres formats reçoivent le
    // défaut (échelle animée) — comportement inchangé.
    echelle_qualitative: {
        variantes: [
            { motif: 'Relie chaque événement', pages: CP_RELIER_PAGES },
        ],
        defaut: CP_ECHELLE,
    },
    droite_graduee_probabilite: CP_DROITE,
    // Variante par motif : « Parmi les situations suivantes » est exclusif au
    // QCM hasard ; les formulations saisie (« issues ») reçoivent le défaut.
    issues_experience_aleatoire: {
        variantes: [
            { motif: 'Parmi les situations suivantes', pages: CP_HASARD_PAGES },
        ],
        defaut: CP_ISSUES,
    },
};

export default CP_679;
